import { render, staticRenderFns } from "./LensSwitcherDropdown.vue?vue&type=template&id=b2eaec30&scoped=true"
import script from "./LensSwitcherDropdown.vue?vue&type=script&lang=js"
export * from "./LensSwitcherDropdown.vue?vue&type=script&lang=js"
import style0 from "./LensSwitcherDropdown.vue?vue&type=style&index=0&id=b2eaec30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eaec30",
  null
  
)

export default component.exports